export enum Tab {
    Recipients = 1,
    Attachments = 2,
    CalendarInvite = 3,
    Message = 4
}